import TimeExpiredIcon from 'assets/ver2/icons/time-expired-icon.svg';
import useLang from 'hooks/useLang';
import { functionUtils } from 'utils';
import FxMakePaymentExpiredPopup from '../popups/FxMakePaymentExpiredPopup';

const FxMakePaymentExpiredModal = ({ isShow, title, content, action }) => {
  const { t } = useLang();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  return (
    <FxMakePaymentExpiredPopup
      isOpen={isShow}
      imageSrc={TimeExpiredIcon}
      imagesStyles={{
        width: '150px',
        height: '150px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel2={t('button_back_to_home')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default FxMakePaymentExpiredModal;
